var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCreation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 9c-3.5 0-5.3 4.1-3 6.7-2.5 1.1-4 3.6-4 6.3 0 .6.4 1 1 1h12c.6 0 1-.4 1-1 0-2.7-1.6-5.2-4-6.3 2.3-2.6.4-6.7-3-6.7zm0 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4.9 10H7.1c1.1-5.3 8.7-5.3 9.8 0zM11 6V2c0-1.3 2-1.3 2 0v4c0 1.3-2 1.3-2 0zm4.9 1.2 2.8-2.8c.9-1 2.4.4 1.4 1.4l-2.8 2.8c-.9.9-2.3-.5-1.4-1.4zM6.7 8.6 3.9 5.8c-.9-1 .4-2.3 1.4-1.4l2.8 2.8c.9.9-.5 2.3-1.4 1.4zM22 14h-3.5c-1.3 0-1.3-2 0-2H22c1.3 0 1.3 2 0 2zM2 12h3.5c1.3 0 1.3 2 0 2H2c-1.3 0-1.3-2 0-2z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCreation);
export default __webpack_public_path__ + "static/media/user-creation.ce33b0ba58e4d76d1cdfa97017f016d8.svg";
export { ForwardRef as ReactComponent };